<div class="layout-rightpanel" [ngClass]="{'layout-rightpanel-active': app.rightPanelActive}"
    (click)="app.onRightPanelClick()">
    <div class="right-panel-scroll-content">
        <div class="layout-rightpanel-header">
            <div class="weather-day">Wednesday</div>
            <div class="weather-date">Jan 26</div>
        </div>
        <div class="layout-rightpanel-content">
            <h1>Weather</h1>
            <h2>New York, USA</h2>

            <div class="weather-today">
                <span class="weather-today-value">21&#8451;</span>
                <!-- <img src="assets/layout/images/dashboard/weather-icon-2.svg" alt="manhattan-layout" width="60"/> -->
            </div>
            <ul class="weekly-weather">
                <li>
                    Thursday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-1.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">24</span>
                </li>
                <li>
                    Friday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-3.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">19</span>
                </li>
                <li>
                    Saturday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-4.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">15</span>
                </li>
                <li>
                    Sunday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-1.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">24</span>
                </li>
                <li>
                    Monday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-2.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">21</span>
                </li>
                <li>
                    Tuesday
                    <!-- <img src="assets/layout/images/dashboard/weather-icon-3.svg" alt="manhattan-layout"/> -->
                    <span class="weekly-weather-value">20</span>
                </li>
            </ul>
        </div>
    </div>
</div>
